import { useIntl } from "react-intl";

import { BlueWaveLayoutJSM } from "@/components/signup/layouts";

export const LoggedOutJiraServiceManagementPremium = () => {
    const { formatMessage } = useIntl();
    return (
        <BlueWaveLayoutJSM
            productEditionText={formatMessage({
                id: "WacSignupHeader.cloudPremium",
                defaultMessage: "Cloud Premium"
            })}
        />
    );
};
